(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapfilter-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tf-hero[data-section-id]').forEach(function (section) {
    var radios = section.querySelectorAll('.tf-hero__variant input[type="radio"]');
    var variantInput = section.querySelector('.tf-hero__variant-input');
    var priceEl = section.querySelector('.tf-hero__price-current');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (variantInput) variantInput.value = radio.value;
        section.querySelectorAll('.tf-hero__variant').forEach(function (v) { v.classList.remove('is-selected'); });
        radio.closest('.tf-hero__variant').classList.add('is-selected');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmo-hero-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.velmo-hero[data-section-id]').forEach(function (section) {
    var thumbs = section.querySelectorAll('.velmo-hero__thumb');
    var slides = section.querySelectorAll('.velmo-hero__slide');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = Number(thumb.dataset.index);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (slides[idx]) slides[idx].classList.add('is-active');
      });
    });

    var radios = section.querySelectorAll('.velmo-hero__bundle-option input[type="radio"]');
    var variantInput = section.querySelector('.velmo-hero__variant-input');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (variantInput) variantInput.value = radio.value;
        section.querySelectorAll('.velmo-hero__bundle-option').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        radio.closest('.velmo-hero__bundle-option').classList.add('is-selected');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmora-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      var toggleBtns = document.querySelectorAll('.ingredients__toggle');
      toggleBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var targetId = btn.dataset.target;
          var list = document.getElementById(targetId);
          var isExpanded = btn.getAttribute('aria-expanded') === 'true';
          var hiddenItems = list.querySelectorAll('.ingredient-item--hidden');

          if (!isExpanded) {
            hiddenItems.forEach(function(item) {
              item.style.display = 'block';
            });
            btn.setAttribute('aria-expanded', 'true');
            btn.childNodes[0].nodeValue = btn.dataset.labelLess + ' ';
          } else {
            hiddenItems.forEach(function(item) {
              item.style.display = '';
            });
            btn.setAttribute('aria-expanded', 'false');
            btn.childNodes[0].nodeValue = btn.dataset.labelMore + ' ';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmora-ugc-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      // Utilise data-section-id (pas de Liquid ici — cf. règle feedback)
      document.querySelectorAll('.velmora-ugc-slider').forEach(function(sectionEl) {
        var sectionId = sectionEl.dataset.sectionId;
        if (!sectionId) return;

        if (typeof Swiper === 'undefined') return;

        new Swiper('.velmora-ugc-swiper-' + sectionId, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          centeredSlides: true,
          loop: true,
          navigation: {
            prevEl: '.velmora-ugc-prev-' + sectionId,
            nextEl: '.velmora-ugc-next-' + sectionId,
          },
          pagination: {
            el: '.velmora-ugc-pagination-' + sectionId,
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20,
              centeredSlides: false,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 24,
              centeredSlides: false,
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
